<div class="d-flex align-items-center">
  <button (click)="doPlusAction.emit()"
          *ngIf="withPlus"
          class="btn btn-primary btn-gradient btn-sm">
    <span>+</span>
  </button>
  <label class="information-label-text" [class.ml10px]="withPlus">{{label}}</label>
</div>
<div class="information-value-text">
  <ng-container *ngIf="isLoading; else textValue">
    <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
    <span class="visually-hidden">Chargement...</span>
  </ng-container>
  <ng-template #textValue>
    {{value ?? ' - '}}
  </ng-template>
</div>
